import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Starter } from '@/components/WelcomeScreen/Starter';
import { WelcomeGreeting } from '@/components/WelcomeScreen/WelcomeGreeting';
import styles from './WelcomeWrapper.module.scss';
export const WelcomeWrapper = ({ welcomeScreen }) => {
    var _a;
    return (_jsxs("div", { className: cn(styles.container), children: [(welcomeScreen === null || welcomeScreen === void 0 ? void 0 : welcomeScreen.enabled) && (_jsx(WelcomeGreeting, { greeting: welcomeScreen.greeting })), _jsx("div", { className: styles.starterContainer, children: (_a = welcomeScreen === null || welcomeScreen === void 0 ? void 0 : welcomeScreen.starters) === null || _a === void 0 ? void 0 : _a.map((starter) => (_jsx(Starter, { title: starter }, starter))) })] }));
};
